// 操作説明資料（PDF）の配信先。public/docs 配下に置いたものがそのまま公開される。
// 資料の元データは docs/manual/*.html。差し替え時はPDFを再出力して public/docs を上書きする。
const withBaseUrl = (path) => `${process.env.BASE_URL || '/'}${path}`.replace(/([^:]\/)\/+/g, '$1');

export const IES4_IMPORT_MANUAL_URL = withBaseUrl('docs/ies4_import_manual.pdf');
export const IES4_BULK_IMPORT_MANUAL_URL = withBaseUrl('docs/ies4_bulk_import_manual.pdf');
